<template>
	<!-- Footer -->
	<footer class="iv2-footer theme-c__footer-bg f-14">
		<div class="iv2-footer__container theme-c__footer-text">
			<div class="row">
				<div class="col-xl-6 text-left">
					<div class="row">
						<div v-if="general.logos" class="iv2-footer__logo col-md-3">
							<router-link to="/">
								<img
									:src="general.logos.basic_type2"
									class="iv2-footer__logo-img"
									:alt="general.profile.name"
								/>
							</router-link>
						</div>
						<div v-if="general.profile" class="col-md-9">
							<p style="font-size: 14px;" class="m-0">
								{{ general.profile.name }}
								<br />
								{{ "〒" + general.profile.zipcode }}&emsp;
								{{
								general.profile.address_pref +
								general.profile.address_city +
								general.profile.address_town +
								general.profile.address_build
								}}
							</p>
							<div class="d-flex">
								<p
									v-if="general.profile.tel != ''"
									style="font-size: 14px;"
									class="m-0 mr-3"
								>{{ "TEL&nbsp;" + general.profile.tel }}</p>
								<p v-if="general.profile.fax != ''" style="font-size: 14px;" class="m-0">
									{{
									"FAX&nbsp;" + general.profile.fax
									}}
								</p>
							</div>
							<div v-if="sns.facebook" class="iv2-footer__sns mt-3">
								<span
									v-if="sns.facebook.status == 0 && sns.instagram.status == 0 && sns.twitter.status == 0 && sns.line.status == 0 && rss.outbound.status == 0"
								></span>
								<span v-else class="size-14">{{ sns_heading }}</span>
								<ul class="p-0" style="display: flex; list-style: none;">
									<li v-if="sns.facebook">
										<a
											v-if="sns.facebook.status == 1"
											:href="sns.facebook.url"
											class="iv2-footer__sns-link theme-c__footer-link"
											target="_blank"
											rel="noopener"
										>
											<i class="iv2-footer__sns-icon text-center fab fa-facebook-f"></i>
										</a>
									</li>
									<li v-if="sns.instagram">
										<a
											v-if="sns.instagram.status == 1"
											:href="sns.instagram.url"
											class="iv2-footer__sns-link theme-c__footer-link"
											target="_blank"
											rel="noopener"
										>
											<i class="iv2-footer__sns-icon text-center fab fa-instagram"></i>
										</a>
									</li>
									<li v-if="sns.twitter">
										<a
											v-if="sns.twitter.status == 1"
											:href="sns.twitter.url"
											class="iv2-footer__sns-link theme-c__footer-link"
											target="_blank"
											rel="noopener"
										>
											<i class="iv2-footer__sns-icon text-center fab fa-twitter"></i>
										</a>
									</li>
									<li v-if="sns.line">
										<a
											v-if="sns.line.status == 1"
											:href="sns.line.url"
											class="iv2-footer__sns-link theme-c__footer-link"
											target="_blank"
											rel="noopener"
										>
											<i class="iv2-footer__sns-icon text-center fab fa-line"></i>
										</a>
									</li>
									<li v-if="rss.outbound">
										<a
											v-if="rss.outbound.status == 1"
											:href="rss.outbound.href"
											class="iv2-footer__sns-link theme-c__footer-link"
											target="_blank"
											rel="noopener"
										>
											<i class="iv2-footer__sns-icon text-center fas fa-rss"></i>
										</a>
									</li>
								</ul>
							</div>
						</div>
						<p class="col-12" style="font-size: 14px;">{{ general.site_description }}</p>
					</div>
				</div>
				<div class="iv2-footer__nav col-xl-6 text-left">
					<p>{{ menu_title }}</p>
					<div class="d-flex" style="height: 80%;">
						<ul v-if="footer_menu.length > 0" class="iv2-footer__nav-list">
							<li v-for="nav in footer_menu.slice(0, 6)" :key="nav.id" class="iv2-footer__nav-item">
								<router-link
									v-if="nav.link_type == 'internal'"
									:to="nav.url"
									class="iv2-footer__nav-link theme-c__footer-link"
								>{{ nav.name }}</router-link>
								<a
									v-else-if="nav.link_type == 'external'"
									v-bind:href="nav.url"
									:target="nav.target_type"
									rel="noopener"
									class="iv2-footer__nav-link theme-c__footer-link"
								>{{ nav.name }}</a>
								<ul v-if="!nav.children.length == false" class="iv2-footer__nav-list list-unstyled">
									<li v-for="cNav in nav.children" :key="cNav.id" class="iv2-footer__nav-item">
										<router-link
											v-if="cNav.link_type == 'internal'"
											:to="cNav.url"
											class="iv2-footer__nav-link theme-c__footer-link"
										>{{ cNav.name }}</router-link>
										<a
											v-else-if="cNav.link_type == 'external'"
											:href="cNav.url"
											@click="activeMenu = false"
											:target="cNav.target_type"
											rel="noopener"
											class="iv2-footer__nav-link theme-c__footer-link"
										>{{ cNav.name }}</a>
									</li>
								</ul>
							</li>
						</ul>
						<ul v-if="footer_menu.length > 6" class="iv2-footer__nav-list">
							<li v-for="nav in footer_menu.slice(6,12)" :key="nav.id" class="iv2-footer__nav-item">
								<router-link
									v-if="nav.link_type == 'internal'"
									:to="nav.url"
									class="iv2-footer__nav-link theme-c__footer-link"
								>{{ nav.name }}</router-link>
								<a
									v-else-if="nav.link_type == 'external'"
									v-bind:href="nav.url"
									:target="nav.target_type"
									rel="noopener"
									class="iv2-footer__nav-link theme-c__footer-link"
								>{{ nav.name }}</a>
								<ul v-if="!nav.children.length == false" class="iv2-footer__nav-list list-unstyled">
									<li v-for="cNav in nav.children" :key="cNav.id" class="iv2-footer__nav-item">
										<router-link
											v-if="cNav.link_type == 'internal'"
											:to="cNav.url"
											class="iv2-footer__nav-link theme-c__footer-link"
										>{{ cNav.name }}</router-link>
										<a
											v-else-if="cNav.link_type == 'external'"
											:href="cNav.url"
											@click="activeMenu = false"
											:target="cNav.target_type"
											rel="noopener"
											class="iv2-footer__nav-link theme-c__footer-link"
										>{{ cNav.name }}</a>
									</li>
								</ul>
							</li>
						</ul>
						<ul v-if="footer_menu.length > 12" class="iv2-footer__nav-list">
							<li v-for="nav in footer_menu.slice(12)" :key="nav.id" class="iv2-footer__nav-item">
								<router-link
									v-if="nav.link_type == 'internal'"
									:to="nav.url"
									class="iv2-footer__nav-link theme-c__footer-link"
								>{{ nav.name }}</router-link>
								<a
									v-else-if="nav.link_type == 'external'"
									v-bind:href="nav.url"
									:target="nav.target_type"
									rel="noopener"
									class="iv2-footer__nav-link theme-c__footer-link"
								>{{ nav.name }}</a>
								<ul v-if="!nav.children.length == false" class="iv2-footer__nav-list list-unstyled">
									<li v-for="cNav in nav.children" :key="cNav.id" class="iv2-footer__nav-item">
										<router-link
											v-if="cNav.link_type == 'internal'"
											:to="cNav.url"
											class="iv2-footer__nav-link theme-c__footer-link"
										>{{ cNav.name }}</router-link>
										<a
											v-else-if="cNav.link_type == 'external'"
											:href="cNav.url"
											@click="activeMenu = false"
											:target="cNav.target_type"
											rel="noopener"
											class="iv2-footer__nav-link theme-c__footer-link"
										>{{ cNav.name }}</a>
									</li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<hr class="iv2-footer__hr theme-c__footer-hr" />
			<div class="iv2-footer__copyright text-center">
				<small class="copyright text-center">{{ general.copyright }}</small>
			</div>
		</div>
	</footer>
</template>
<script>
export default {
	data() {
		return {
			general: [],
			footer_menu: [],
			sns: [],
			rss: [],

			sns_heading: "FOLLOW ME",
			menu_title: "MENU"
		};
	},

	created() {
		this.axios.get("/json/navigations.json").then(response => {
			this.footer_menu = response.data.navs.footer_menu;
		});
		this.axios.get("/json/settings.json").then(response => {
			this.general = response.data.settings.general;
			this.sns = response.data.settings.sns;
		});
		this.axios.get("/json/rss.json").then(response => {
			this.rss = response.data.rss;
		});
	}
};
</script>

<style lang="scss">
.iv2-footer__container {
	width: 90%;
	margin: auto;

	.iv2-footer__logo {
		margin: 20px 0;
	}

	.iv2-footer__nav-list {
		display: inline-block;
		width: 50%;
		vertical-align: top;
		margin-bottom: 30px;
		padding-left: 25px;
		border-left: 1px solid;
		padding-top: 30px;
		margin-right: 5px;

		.iv2-footer__nav-item {
			font-size: 14px;
			display: block;
			width: 100%;

			.iv2-footer__nav-link {
				padding: 0;
				text-decoration: none;

				&::before {
					content: "-";
					margin-right: 5px;
				}
			}

			> .iv2-footer__nav-list {
				display: block;
				margin-bottom: 0;
				margin-right: 0px;
				padding-top: 0;
				padding-left: 0;
				border-left: 0;

				.iv2-footer__nav-item {
					.iv2-footer__nav-link {
						margin-left: 20px;
						&::before {
							content: none;
						}
					}
				}
			}
		}
	}

	.iv2-footer__sns {
		.iv2-footer__sns-link {
			margin-right: 15px;

			.iv2-footer__sns-icon {
				width: 15px;
			}
		}
	}

	.iv2-footer__hr {
		padding: 0;
	}
}

/* PC */
@media (min-width: 1200px) {
	.iv2-footer {
		padding: 50px 0;
	}
}

/* TABLET or SP */
@media (max-width: 1199px) {
	.iv2-footer {
		padding: 20px 0;
	}

	.iv2-footer__container {
		.iv2-footer__hr {
			margin: 10px 0;
		}
	}
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
}

/* SP Only */
@media (max-width: 767px) {
	.iv2-footer {
		margin-bottom: 60px;
		padding-bottom: calc(env(safe-area-inset-bottom));
	}

	.iv2-footer__container {
		padding-bottom: 20px;
		.iv2-footer__logo {
			width: 40%;
			margin: auto;
			margin-bottom: 30px;
			text-align: center;
		}

		.iv2-footer__nav {
			display: none;
		}
	}
}
</style>
